import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=18062534&scoped=true&"
import script from "./Glossary.js?vue&type=script&lang=js&"
export * from "./Glossary.js?vue&type=script&lang=js&"
import style0 from "./Glossary.vue?vue&type=style&index=0&id=18062534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18062534",
  null
  
)

export default component.exports